// extracted by mini-css-extract-plugin
var _1 = "ProfileFlatsWidgetItem-moduleProfileFlatsWidgetItem__dxh2t ListItem-moduleListItem__NInUA";
var _2 = "ProfileFlatsWidgetItem-modulehover__N_a4u";
export { _1 as "ProfileFlatsWidgetItem", _2 as "hover" }
